
import { cn } from "../lib/utils";

function Card( { className, ...props } ) {

  return (

    <div

      className={ cn( "bg-white flex flex-col rounded-xl shadow-card", className ) }

      { ...props }

    />

  )

}

function CardContent( { className, ...props } ) {

  return (

    <div

      className={ cn( "p-6 pb-11 md:px-16 md:py-11", className ) }
      
      { ...props }

    />

  )

}

function CardHeader( { className, ...props } ) {
  
  return (

    <div

      className={ cn( "bg-card-gradient h-16 xs:h-20 sm:h-24 lg:h-33 flex items-center justify-center rounded-t-xl", className ) }

      { ...props }

    />

  )

}

function CardTitle( { className, ...props } ) {

  return (

    <h2

      className={ cn( "font-bold text-blue-primary text-lg xs:text-2xl sm:text-3xl lg:text-[42px]", className ) }

      { ...props }

    />

  )

}

export {

  Card,

  CardContent,

  CardHeader,

  CardTitle,
  
}
